export const send = ({formData, url}) => (dispatch) => {
    const csrfToken = document.head.querySelector("[name~=csrf-token][content]").content;

    dispatch({
        type: 'FORM_SENDING'
    });
    fetch(url, {
        headers: {
            "Accept": "application/json",
            "X-CSRF-Token": csrfToken
        },
        'method': 'POST',
        body: formData
    }).then((response) => {
        let data = response.json();
        if (response.status === 200) {
            dispatch({
                type: 'FORM_SENT'
            });

        } else if (response.status === 500) {
            dispatch({
                type: 'FORM_ERROR'
            });
            alert(response.statusText);
        } else {
            dispatch({
                type: 'FORM_ERROR'
            });
            data.then(function (result) {
                let errorMessage = ''
                for (let error in result.errors) {
                    errorMessage += result.errors[error][0] + "\n";
                }
                alert(errorMessage);
            });

        }
    }).catch((error) => {
        console.log(error);
    })

}

